//---------------------------------------------------------------//
// Global Variables first
//---------------------------------------------------------------//
const $body = $(document.body);
const menuChange = 1000; // width at which the dekstop menu is show

//---------------------------------------------------------------//
// Display/hide the header's Search bar element
//---------------------------------------------------------------//

let searchBarOpen = false;

$('#begin-search').on('click', function (e) {
  e.preventDefault();

  if (!searchBarOpen) {
    // search bar is not open, so open it
    // first close the mobile menu if it is open
    if (menuBool) {
      closeMobileMenu();
    }
    openHeaderSearchBar();

    // In case we need to submit the form via the search icon faux button element
    $('#search-bar-container .faux-search-btn').on('click', function () {
      $('#search-bar-container form').submit();
    });
  } else {
    // search bar is open, so close it
    closeHeaderSearchBar();
  }
});

function openHeaderSearchBar() {
  $('#search-bar-container').slideDown(300);
  $('#begin-search a').addClass('active');
  $('#begin-search a span').toggleClass('icon-search icon-close');
  $('#search-bar-container input[name="search_site"]').focus();
  searchBarOpen = true;
}

function closeHeaderSearchBar() {
  $('#search-bar-container').slideUp(300);
  $('#begin-search a').removeClass('active');
  $('#begin-search a span').toggleClass('icon-search icon-close');
  searchBarOpen = false;
}

//---------------------------------------------------------------//
// Move the User Details Menu when on mobile
//---------------------------------------------------------------//

// This will move the User Details Menu from the top bar into the mobile menu
// when on mobile. It will move it back when not on mobile.

// function to move the User Details Menu to mobile menu
function moveUserDetailsMenu() {
  if (window.innerWidth < menuChange) {
    // Remove the User Details Menu from its original place in the DOM and place within main menu
    $('.top-bar-actions li.user-details').appendTo(
      'nav.main-menu > ul.menu-level-1'
    );
  } else {
    // Place the User Details Menu back into its original position within the top
    $('nav.main-menu > ul.menu-level-1 li.user-details').insertBefore(
      '.top-bar-actions li.menu-button-container'
    );
  }
}

// run the function immediately and then again after window resize
moveUserDetailsMenu();
$(window).resize(moveUserDetailsMenu);

//---------------------------------------------------------------//
// Move the Sidebar Menu (if present) when on mobile
//---------------------------------------------------------------//

// This will move the Sidebar Menu from the sidebar area into the
// mobile menu when on mobile. It will move it back when not on mobile.

// variables first
let sidebarMenuMoved = false;

// function to move the User Details Menu to mobile menu
function moveSidebarMenu() {
  if (window.innerWidth < menuChange && $('#sidebar').length) {
    if (!sidebarMenuMoved) {
      var activeMenuItem = $('nav.main-menu > ul.menu-level-1 > li.active a');
      activeMenuItem.replaceWith(function () {
        return (
          '<span>' +
          this.innerHTML +
          '<span class="icon-arrow-right"></span></span>'
        );
      });
    }

    // Remove the Sidebar Menu from its original place in the DOM and place within main mobile menu
    // in the appropiate submenu item.
    $('#sidebar ul.sidebar-menu')
      .appendTo('nav.main-menu > ul.menu-level-1 > li.active')
      .addClass('menu-level-2 from-sidebar')
      .find('.sidebar-menu-level-2')
      .addClass('menu-level-3')
      .end()
      .find('.sidebar-menu-level-3')
      .addClass('menu-level-4');
    sidebarMenuMoved = true;
  } else {
    // Place the Sidebar Menu back into its original position within the sidebar.
    $('nav.main-menu > ul.menu-level-1 ul.sidebar-menu')
      .appendTo('#sidebar .sidebar-content')
      .removeClass('menu-level-2')
      .find('.sidebar-menu-level-2')
      .removeClass('menu-level-3')
      .end()
      .find('.sidebar-menu-level-3')
      .removeClass('menu-level-4')
      .end()
      .find('.icon-arrow-right')
      .remove();
    sidebarMenuMoved = false;
  }
}

// run the function immediately and then again after window resize
moveSidebarMenu();
$(window).resize(moveSidebarMenu);

// Reset the menus and such by forcing a page reload as browser sizes up from mobile
let pageHasReset = 0;

$(window).resize(function () {
  if (window.innerWidth <= 1000 && pageHasReset === 0) {
    pageHasReset = 1;
  } else if (window.innerWidth > 1000 && pageHasReset === 1) {
    pageHasReset = 0;
  }
});

// Reset things by forcing a page reload as device orientation changes
window.addEventListener('orientationchange', function () {
  $('#main-page-wrapper').css('opacity', 0.5);
  $('#loading').show();
  setTimeout(function () {
    location.reload(false);
  }, 750);
});

//---------------------------------------------------------------//
// Mobile Menu Behaviors
//---------------------------------------------------------------//

// Taken directly from the Altos Parent Theme's menu.js file

const OPEN = 'js-menu-open';
const submenuOpen = 'sub-menu-open';
const activeItem = 'item-active';
const activeChildren = 'active-children';
const $hamburger = $('.menu-button');
const $navItemWithChildren = $('li.is-parent > span');
const $mainItemsToToggle = $('.main-menu');

let lastSize = null;
let menuBool = false;

// handle clicking on menu button
$hamburger.on('click', () => {
  if (menuBool == false) {
    // first close the search bar if it is open
    if (searchBarOpen) {
      closeHeaderSearchBar();
    }
    openMobileMenu();
  } else {
    closeMobileMenu();
  }
});

// function to run when opening hamburger
function openMobileMenu() {
  $mainItemsToToggle.slideDown();
  $hamburger.addClass('active');
  $body.addClass(OPEN);
  $('#main-page-wrapper').addClass('has-mobilemenu-open');
  setBaseMenu(); // need this to run for mobile menu behaviors
  menuBool = !menuBool;
}

// function to run when closing hamburger
function closeMobileMenu() {
  $mainItemsToToggle.slideUp();
  $hamburger.removeClass('active');
  $body.removeClass(OPEN);
  $('#main-page-wrapper').removeClass('has-mobilemenu-open');
  $('.sidebar-menu').removeClass(submenuOpen);
  $('.main-menu').removeClass('intoSecondLevel').removeClass('intoThirdLevel');
  //setBaseMenu(); // need this to run for mobile menu behaviors
  menuBool = !menuBool;
}

// when clicking on nav items with children sub menus
$navItemWithChildren.on('click', (evt) => {
  if (window.innerWidth < menuChange) {
    const $this = $(evt.currentTarget);

    $(`.${activeItem}`)
      .not($this)
      .not($this.parents('.menu-level-2').siblings())
      .removeClass(activeItem)
      .parent()
      .removeClass(activeChildren);

    $this.toggleClass(activeItem).parent().toggleClass(activeChildren);

    // look for any open submenus that are not itself or a parent
    // and close them and remove class
    $(`.${submenuOpen}`)
      .not($this.parents())
      .not($this.next('ul'))
      .slideToggle()
      .toggleClass(submenuOpen);

    // toggle the submenu and class
    $this
      .next('ul:not(.menu-level-3):not(.menu-level-4)')
      .toggleClass(submenuOpen);
    //$this.next('ul.menu-level-2').toggleClass(submenuOpen);

    // slide toggle the 3rd and 4th level menu items differently
    $this.next('ul.menu-level-3').slideToggle().toggleClass(submenuOpen);
    $this.next('ul.menu-level-4').slideToggle().toggleClass(submenuOpen);
  }
});

// add function to close down menu if going from mobile to desktop
window.addEventListener('resize', closeDownMenuResizing, {
  passive: true,
});

function closeDownMenuResizing() {
  const thisWidth = window.innerWidth;
  if (lastSize < menuChange && thisWidth >= menuChange && menuBool) {
    $mainItemsToToggle.css('display', '');
    $hamburger.removeClass('active');
    $body.removeClass(OPEN);
    $('#main-page-wrapper').removeClass('has-mobilemenu-open');
    $(`.${activeItem}`)
      .removeClass(activeItem)
      .parent()
      .removeClass(activeChildren);
    $(`.${submenuOpen}`).css('display', '').removeClass(submenuOpen);
    menuBool = false;
  }

  lastSize = thisWidth;
}

//---------------------------------------------------------------//
// Get & Set the Base Menu Items for Mobile Menu Behaviors
//---------------------------------------------------------------//

// Handle getting the base menu item
var baseItem;
var baseDepth;

function getMenuBase() {
  var testDepth = $('nav.main-menu').find('.active, .active-children');

  if (testDepth.length == 2) {
    //subnav
    baseItem = testDepth.eq(testDepth.length - 1);
    baseDepth = 2;
  } else if (testDepth.length > 2) {
    //subsubnav
    baseItem = testDepth.eq(testDepth.length - 1);
    baseDepth = 3;
  }
}
// Get base menu item immediately - will need for mobile
getMenuBase();

// Handle setting the base menu item
// is triggered to run when the mobile menu button is clicked
function setBaseMenu() {
  if (baseDepth == 1) {
    //$('nav.main-menu').removeClass('intoSecondLevel');
  } else if (baseDepth == 2) {
    $('nav.main-menu').addClass('intoSecondLevel');
    $(baseItem).parent().parent().addClass(submenuOpen); // adds the sub-menu-open class to the appropiate ul to begin journey
  } else if (baseDepth == 3) {
    $('nav.main-menu').addClass('intoSecondLevel').addClass('intoThirdLevel');
    $(baseItem).parent().parent().parent().parent().addClass(submenuOpen); // adds the sub-menu-open class to the appropiate ul to begin journey
  } else {
    $('nav.main-menu')
      .removeClass('intoSecondLevel')
      .removeClass('intoThirdLevel');
  }
}

//---------------------------------------------------------------//
// The mobile "Faux Header" and "Swiping Menu" affects
//---------------------------------------------------------------//

// Add in the faux "header" li link elements to the top of menu-level-2 so users can go back
$('nav.main-menu > ul.menu-level-1 > li.is-parent > span').each(function () {
  var menuTitle = $(this).text();
  var menuTitleCleaned = menuTitle.toLowerCase().trim().replace(/\s+/g, '-');

  // test to see if we are dealing with a product or not
  // if product, create the new LI header element with the logo image, otherwise, just plain text
  if (
    menuTitleCleaned.match(
      /^(insider|trends-report|datacast|alliance|partnership|consulting)$/
    )
  ) {
    var newLiHeader = $(
      '<li class="fauxheader"><span class="faux-back"><span class="icon-arrow-left"></span> All</span><span class="faux-title firstLevel"><img src="/images/product/icons/' +
        menuTitleCleaned +
        '-icon.svg" alt="' +
        menuTitle +
        ' Logo" /></span></li>'
    );
  } else {
    var newLiHeader = $(
      '<li class="fauxheader"><span class="faux-back"><span class="icon-arrow-left"></span> Back</span></li>'
    );
  }

  $(this).next('ul.menu-level-2').prepend(newLiHeader);
});

// Clicking a fauxheader li element's icon to go back up a level in the menu
$('body').on('click', 'li.fauxheader span.faux-back', function (e) {
  e.preventDefault();
  $('nav.main-menu').removeClass('intoSecondLevel');
  $('nav.main-menu > ul.menu-level-1 > li').removeClass('open');
  // need to remove the submenuOpen class, but only after the .5s transition of the "swipe menu" has occurred
  // otherwise the menu-level-2 would disappear before the "swipe" completes
  setTimeout(function () {
    $('nav.main-menu > ul.menu-level-1 > li > ul').removeClass(submenuOpen);
  }, 500);
});

// When click on first level nav items
$('nav.main-menu > ul.menu-level-1 > li.is-parent > span').on(
  'click',
  function (e) {
    e.preventDefault();
    $('nav.main-menu').addClass('intoSecondLevel');
  }
);
